import { Component, Input, Output, OnChanges, EventEmitter } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { CheckboxPrompt } from '../../../../../forms/models'
import { QuestionViewService, IQuestionAnswer } from '../../'

const REPEATED_CLICK_EVENT_MS_TRESHOLD = 50

@Component({
  selector: 'mp-select-one-or-more-choice-view',
  templateUrl: './select-one-or-more-choice-view.html'
})
export class SelectOneOrMoreChoiceViewComponent implements OnChanges {
  @Input() public answerChoicePrompt: CheckboxPrompt
  @Input() public formGroup: FormGroup
  @Input() public selectStrategies = []

  @Output() public optionSelected: EventEmitter<IQuestionAnswer> = new EventEmitter()

  public reviewMode: boolean = false

  private _previousClickEvent = { timeStamp: 0 }
  private _cachedFormValue = {}

  public constructor(
    private _questionViewService: QuestionViewService
  ) { }

  public ngOnChanges() {
    this.reviewMode = this._questionViewService.reviewMode
    this._cachedFormValue = this.formGroup.value
  }

  public selectOption(value, index, event: MouseEvent) {
    if (this.reviewMode || this.formGroup.disabled || this._isRepeatedEvent(event)) {
      event.preventDefault()
      return
    }
    this._previousClickEvent = event
    const answerChoiceFormGroup = this._cachedFormValue[this.answerChoicePrompt.key]
    const formValue = answerChoiceFormGroup[index]
    formValue[value] = !formValue[value]

    this.selectStrategies.forEach((strategy) => strategy(answerChoiceFormGroup, index, this))

    this.formGroup.patchValue(this._cachedFormValue)

    let choiceId
    const questionAnswers = answerChoiceFormGroup.reduce((previous, answerValue) => {
      choiceId = this._getChoiceIdFromAnswerValue(answerValue)
      if (answerValue[choiceId]) {
        previous.push({
          choiceId: choiceId,
          value: ''
        })
      }
      return previous
    }, [])
    this.optionSelected.emit(questionAnswers)
  }

  public isSelected(option) {
    return this.formGroup.value.answerChoice.some((choice) => choice[option.value])
  }

  public isCorrect(option): boolean {
    return this._questionViewService.question.isAnswerChoiceCorrect(option.value)
  }

  private _getChoiceIdFromAnswerValue(answerValue): string {
    return Object.keys(answerValue)[0]
  }

  private _isRepeatedEvent(event: MouseEvent) {
    return event.timeStamp - this._previousClickEvent.timeStamp < REPEATED_CLICK_EVENT_MS_TRESHOLD
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/choice-views/select-one-or-more-choice-view/select-one-or-more-choice-view.component.ts